import React, { useState } from 'react';
import './Header.css'
import Logo from '../Assets/logo.png'
import { Link } from 'react-router-dom'
import { GiHamburgerMenu } from 'react-icons/gi'
import { GrFormClose } from 'react-icons/gr'
import { BiChevronDown, BiChevronUp } from 'react-icons/bi'

function Header() {

  const [dropdown, setDropdown] = useState(false)

  const [options, setOptions] = useState(false)

  const [current, setCurrent] = useState('')

  const handleClick = () => {
    setOptions(!options)
    setDropdown(false)
    setCurrent('')
  }

  return (
    <>
      <div className='header'>
        <div className='header-logo'>
          <Link to='/'>
            <img src={Logo} className='logo' alt="company-logo" />
          </Link>
        </div>
        <div className='header-options'>
          <div className='how-we-help'>
            <div className='items' style={{ cursor: 'pointer', padding: '5vh 0' }}>How We Help</div>
            <div className='how-we-help-dropdown'>
              <div>
                <Link className='dropdown-links' to='/hiring-and-selection'>Hiring and Selection</Link>
                <Link className='dropdown-links' to='/training-and-development'>Training and Development</Link>
                <Link className='dropdown-links' to='/leadership-identification'>Leadership Identification</Link>
                {/* <Link className='dropdown-links' to='/team-building'>Team Building and Analytics</Link> */}
                <Link className='dropdown-links' to='/culture-and-values'>Organization Culture Building</Link>
              </div>
              {/* <div>
                <a>item5</a>
                <a>item6</a>
                <a>item7</a>
              </div> */}
            </div>
          </div>

          <div className='how-we-help'>
            <div className='items' style={{ cursor: 'pointer', padding: '5vh 0' }}>Assessment Corner</div>
            <div className='how-we-help-dropdown'>
              <div>
                {/* <Link className='dropdown-links' to='/pratibimb'>Pratibimb (PAVE)</Link> */}
                <Link className='dropdown-links' to='/work-value-attitude'>Work Values and Attitude</Link>
                <Link className='dropdown-links' to='/work-style-performance'>Work Style and Performance Profile</Link>
                <Link className='dropdown-links' to='/cognitive-quotient'>Cognitive Quotient</Link>
                <Link className='dropdown-links' to='/english-proficiency'>English Proficiency</Link>
                {/* <Link className='dropdown-links' to='/communication-skills'>Communication Skills</Link> */}
                <Link className='dropdown-links' to='/leadership-profile'>Leadership Profile</Link>
                {/* <a>item3</a>
                <a>item4</a> */}
              </div>
              {/* <div>
                <a>item5</a>
                <a>item6</a>
                <a>item7</a>
              </div> */}
            </div>
          </div>

          <div className='how-we-help'>
            <div className='items' style={{ cursor: 'pointer', padding: '5vh 0' }}>Our Approach</div>
            <div className='how-we-help-dropdown'>
              <div>
                <Link className='dropdown-links' to='/triple-i'>Triple i</Link>
              </div>
              {/* <div>
                <a>item5</a>
                <a>item6</a>
                <a>item7</a>
              </div> */}
            </div>
          </div>

          {/* <div className='how-we-help'>
            <div className='items' style={{cursor:'pointer',padding:'5vh 0'}}>Partners</div>
            <div className='how-we-help-dropdown'>
              <div>
                <Link className='dropdown-links' to='/partners'>Strategiclinks.in Partners</Link>
                <Link className='dropdown-links' to='/become-a-partner'>Become a Strategiclinks.in Partner</Link>
                <Link className='dropdown-links' to='/certification'>Get SLCertified!</Link>
              </div>
            </div>
          </div>

          <div className='how-we-help'>
            <div className='items' style={{cursor:'pointer',padding:'5vh 0'}}>About</div>
            <div className='how-we-help-dropdown'>
              <div>
                <Link className='dropdown-links' to='/founder'>Our Founder</Link>
                <Link className='dropdown-links' to='/scientific-advisors'>Scientific Advisors</Link>
                <Link className='dropdown-links' to='/mission-vision-values'>Mission, Vision and Values</Link>
                <Link className='dropdown-links' to='/faqs'>FAQs</Link>
                <Link className='dropdown-links' to='/careers'>Careers</Link>
                <Link className='dropdown-links' to='/contact'>Contact Us</Link>
              </div>
            </div>
          </div> */}

          <Link to="/register">
            <div className='header-page-button'>
              Ask us
            </div>
          </Link>
        </div>






        <div className='mobile-buttons'>
          {
            dropdown ?
              <GrFormClose style={{ marginRight: '5vw' }} size={30} onClick={() => setDropdown(false)} />
              :
              <GiHamburgerMenu style={{ marginRight: '5vw' }} onClick={() => setDropdown(true)} size={25} />
          }
        </div>

        {
          dropdown &&
          <div style={{
            background: 'white',
            width: '100%',
            height: '100vh',
            position: 'absolute',
            top: '10vh',
            borderTop: '1px solid #e2e2e2',
            textAlign: 'center'
          }}>

            <div style={{ margin: '5vh 0', fontSize: '2.5vh' }}>

              <div style={{ margin: '3vh 0' }}>
                <div onClick={() => setCurrent('1')} style={{ display: 'flex', justifyContent: 'center' }}>
                  <div className='mobile-option-heading'>How We Help </div>
                  <div>
                    {
                      current === '1' ?
                        <BiChevronUp size={20} />
                        :
                        <BiChevronDown size={20} />
                    }
                  </div>
                </div>
                {
                  current === '1' &&
                  <div>
                    <div onClick={handleClick}><Link className='mobile-links' to='/hiring-and-selection'>Hiring and Selection</Link></div>
                    <div onClick={handleClick}><Link className='mobile-links' to='/training-and-development'>Training and Development</Link></div>
                  </div>
                }
              </div>


              <div style={{ margin: '3vh 0' }}>
                <div onClick={() => setCurrent('2')} style={{ display: 'flex', justifyContent: 'center' }}>
                  <div className='mobile-option-heading'>Assessment Corner</div>
                  <div>
                    {
                      current === '2' ?
                        <BiChevronUp size={20} />
                        :
                        <BiChevronDown size={20} />
                    }
                  </div>
                </div>
                {
                  current === '2' &&
                  <div>
                    {/* <div onClick={handleClick}><Link className='mobile-links' to='/pratibimb'>Pratibimb (PAVE)</Link></div> */}
                    <div onClick={handleClick}><Link className='mobile-links' to='/work-value-attitude'>Work Values and Attitude</Link></div>
                    <div onClick={handleClick}><Link className='mobile-links' to='/work-style-performance'>Work Style and Performance Profile</Link></div>
                    <div onClick={handleClick}><Link className='mobile-links' to='/cognitive-quotient'>Cognitive Quotient</Link></div>
                    <div onClick={handleClick}><Link className='mobile-links' to='/english-proficiency'>English Proficiency</Link></div>
                    {/* <div onClick={handleClick}><Link className='mobile-links' to='/communication-skills'>Communication Skills</Link></div> */}
                    <div onClick={handleClick}><Link className='mobile-links' to='/leadership-profile'>Leadership Profile</Link></div>
                  </div>
                }
              </div>


              <div style={{ margin: '3vh 0' }}>
                <div onClick={() => setCurrent('3')} style={{ display: 'flex', justifyContent: 'center' }}>
                  <div className='mobile-option-heading'>Our Approach</div>
                  <div>
                    {
                      current === '3' ?
                        <BiChevronUp size={20} />
                        :
                        <BiChevronDown size={20} />
                    }
                  </div>
                </div>
                {
                  current === '3' &&
                  <div>
                    <div onClick={handleClick}><Link className='mobile-links' to='/triple-i'>Triple i</Link></div>
                  </div>
                }
              </div>


              {/* <div style={{margin:'3vh 0'}}>
              <div onClick={()=>setCurrent('4')} style={{display:'flex',justifyContent:'center'}}>
                <div className='mobile-option-heading'>Partners</div>
                <div>
                  {
                    current==='4' ?
                    <BiChevronUp size={20}/>
                    :
                    <BiChevronDown size={20}/>
                  }
                </div>
              </div> 
              {
                current==='4' &&
                <div>
                  <div onClick={handleClick}><Link className='mobile-links' to='/partners'>Strategiclinks.in Partners</Link></div>
                  <div onClick={handleClick}><Link className='mobile-links' to='/become-a-partner'>Become a Strategiclinks.in Partner</Link></div>
                  <div onClick={handleClick}><Link className='mobile-links' to='/certification'>Get SLCertified!</Link></div>
                </div>
              }
            </div>


            <div style={{margin:'3vh 0'}}>
              <div onClick={()=>setCurrent('5')} style={{display:'flex',justifyContent:'center'}}>
                <div className='mobile-option-heading'>About</div>
                <div>
                  {
                    current==='5' ?
                    <BiChevronUp size={20}/>
                    :
                    <BiChevronDown size={20}/>
                  }
                </div>
              </div> 
              {
                current==='5' &&
                <div>
                  <div onClick={handleClick}><Link className='mobile-links' to='/founder'>Our Founder</Link></div>
                  <div onClick={handleClick}><Link className='mobile-links' to='/scientific-advisors'>Scientific Advisors</Link></div>
                  <div onClick={handleClick}><Link className='mobile-links' to='/mission-vision-values'>Mission, Vision and Values</Link></div>
                  <div onClick={handleClick}><Link className='mobile-links' to='/faqs'>FAQs</Link></div>
                  <div onClick={handleClick}><Link className='mobile-links' to='/careers'>Careers</Link></div>
                  <div onClick={handleClick}><Link className='mobile-links' to='/contact'>Contact Us</Link></div>
                </div>
              }
            </div> */}


              <div onClick={handleClick} className='mobile-contact-button'>

                <Link to="/register" style={{ textDecoration: 'none', color: 'white' }}>Register</Link>

                {/* <Link to="/register" style={{textDecoration:'none',color:'white'}}>Contact Us</Link> */}

              </div>
            </div>

          </div>
        }
      </div>
    </>
  );
}

export default Header;
